import { generateKeys } from '../../../common';
import { paymentMethodMap } from './paymentMethodMap';

export const sourceMethodKeys = generateKeys(paymentMethodMap);
